module.exports = __webpack_public_path__ + "img/icon-highthc.9eb10dc7.svg";